module.exports = __webpack_public_path__ + "media/images/psp/close-823085825ebb2a91a59e0fbb103d87b0.svg";